{
    "translation": {
        "invoices": {
            "note": "Kjære kunde, hvis du betaler med kort, vennligst se bort fra denne fakturaen."
        },
        "flowPicker": {
            "title": "Er du ny eller eksisterende Flex-kunde?",
            "newCustomer": "Jeg vil bli Flex-kunde",
            "existingCustomer": "Jeg er allerede Flex-kunde",
            "nextButton": "Gå videre"
        },
        "lisaAnd": {
            "plans": {
                "selectSubscription": "Velg periode",
                "description": "",
                "VALUE": {
                    "title": "Flex 24 måneder",
                    "description": "Bytt eller avslutt etter 24 mnd"
                },
                "FLEX": {
                    "title": "Full fleksibilitet",
                    "description": "Bytt eller avslutt når du vil",
                    "priceDescription": "i {{months}} mnd, deretter {{price}}"
                },
                "disclaimer": "Prisen gjelder ved godkjent innbytte i angitt tilstand.",
                "welcomeMessage": {
                    "title": "",
                    "paragraphs": [
                        "Samsung Flex er et samarbeid mellom Samsung og Lisa&, som gir deg muligheten til å leie Samsung-produkter fra Lisa&. Egne betingelser gjelder for Samsung Flex fra henholdsvis Samsung og Lisa&."
                    ]
                }
            },
            "cart": {
                "priceFor": "{{price}} \nfor {{months}} months",
                "monthlyCost": "Din månedlige omkostning",
                "accessories": "Tilbehør",
                "prepayToday": "Beløb til betaling i dag",
                "prepayTodayDisclaimer": "{{months}} måned + Tilbehør",
                "showDiscount": "Vis rabattdetaljer",
                "VALUE": {
                    "planName": "med Flex 24 måneder"
                },
                "FLEX": {
                    "planName": "med Full fleksibilitet"
                },
                "totalMonthlyDiscount": "<0>Total månedsrabatt (1-{{months}}) <1></1></0>",
                "totalMonthlyDiscountIncludesBoth": "<0>Inkluderer din foreløpige verdi for Trade in og dine rabatter.</0>"
            }
        },
        "general": {
            "readMore": "Les mer her",
            "images_zero": "",
            "images_one": "1 bilde",
            "images_other": "{{count}} bilder",
            "edit": "Redigere",
            "cancel": "Avbryt",
            "save": "Lagre",
            "close": "Lukk",
            "view": "Vis og håndter",
            "back": "Tilbake",
            "errors": {
                "required": "Dette feltet er obligatorisk"
            }
        },
        "svea": {
            "genericDiscount": "Rabatt",
            "tradeinSubsidy": "Oppdatert innbytteverdi etter Foxway-sertifisert gradering",
            "tradeinSubsidyPlaceholderReversal": "Innbytterabatt justering",
            "tradeinName": "Innbytterabatt",
            "upfrontPaymentProduct": "Forhåndsbetalt: ",
            "upfrontPaymentProductDiscount": "Forhåndsbetalt: ",
            "upfrontPaymentTradeInDiscount": "Forhåndsbetalt: ",
            "reversal": "Annullering: "
        },
        "header": {
            "back": "Tilbake",
            "backLink": "https://shop.samsung.com/no/cart",
            "help": "For spørsmål, ring 21 62 90 97",
            "helpLink": "Mobile: 21 62 90 97",
            "toggleLabel": "Menu",
            "home": "Hjem",
            "login": "Logg inn på din Samsung Flex-konto",
            "loginSubtitle": "Velg innloggingsmåte",
            "loginButton": "Logg inn",
            "logOut": "Logg ut",
            "subscriptions": "Mine enheter",
            "invoices": "Fakturaer",
            "offers": "Tilbud",
            "account": "Min konto",
            "language": {
                "options": {
                    "fi-FI": "Finnish",
                    "sv-SE": "Swedish",
                    "no-NO": "Norwegian",
                    "nb-NO": "Norwegian",
                    "da-DK": "Danish"
                },
                "label": "Velg språk",
                "labelDescription": "Velg språk for å fortsette",
                "selectLabel": "Språkvelger"
            }
        },
        "banner": {
            "title": "Den nye måten å ha en Samsung Galaxy på",
            "subTitle": "Glødende interesse for teknologi, med omtanke"
        },
        "footer": {
            "language": "",
            "languageLink": "",
            "backToTop": "Tilbake til begynnelsen",
            "topNote": {
                "text": "For spørsmål om programmet eller å snakke med kundeservice, vennligst kontakt Samsung på 21 62 90 97.",
                "button": {
                    "text": "Ring kundestøtte 21 62 90 97",
                    "url": "tel:21 62 90 97"
                }
            },
            "copyright": "Copyright© 1995-{{currentYear}} Samsung. Alle rettigheter reservert.",
            "termsAndConditions": "Se fullstendige <1>vilkår</1>",
            "termsAndConditionsLink": "https://resellers.foxway.com/subscriptionterms-no",
            "social": {
                "title": "Følg oss på",
                "items": []
            },
            "terms": [],
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "21 62 90 97",
                            "url": "tel:21 62 90 97"
                        },
                        {
                            "text": "Mandag til Fredag | 08:00 - 21:00"
                        },
                        {
                            "text": "Lørdag | 10:00 - Stengt"
                        },
                        {
                            "text": "Søndag | 10:00 - Stengt"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/no/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Om Samsung Flex",
                    "text": "Lisa& tilbyr privatpersoner muligheten til å leie produkter som Samsung Electronics Nordic AB gjør tilgjengelig innenfor rammen av Samsung Flex. I forbindelse med bestillingen kan kunden også kjøpe enkelte andre produkter av Lisa&.",
                    "links": [
                        {
                            "text": "For mer informasjon, se https://www.samsung.com/no/flex",
                            "url": "https://www.samsung.com/no/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Om Lisa&",
                    "text": "Firmanavn: Lisa & friends AB\nOrganisasjonsnummer: 559315-0955\nPostadresse: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden\nMomsregistreringsnummer: SE559315095501"
                },
                {
                    "title": "Om Samsung",
                    "text": "Firmanavnn: Samsung Electronics Nordic AB\nOrganisasjonsnummer: 556445-4345\nKontaktinformasjon: https://www.samsung.com/no/support/contact/\nBesøksadresse: Støperigata 2, 0 Oslo, Norge\nPostadresse: Box 1235, 164 28 Kista, Sweden\nMomsregistreringsnummer: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "portalFooter": {
            "backToTop": "Tilbake til begynnelsen",
            "copyright": "Kundeportalen og tilhørende tjenester i Samsung Flex leveres av Foxway. Opphavsrett 1995-{{currentYear}} Samsung. Alle rettigheter reservert",
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "21 62 90 97",
                            "url": "tel:21 62 90 97"
                        },
                        {
                            "text": "Mandag til Fredag | 08:00 - 21:00"
                        },
                        {
                            "text": "Lørdag | 10:00 - Stengt"
                        },
                        {
                            "text": "Søndag | 10:00 - Stengt"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/no/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Om Samsung Flex",
                    "text": "Lisa& tilbyr privatpersoner muligheten til å leie produkter som Samsung Electronics Nordic AB gjør tilgjengelig innenfor rammen av Samsung Flex. I forbindelse med bestillingen kan kunden også kjøpe enkelte andre produkter av Lisa&.",
                    "links": [
                        {
                            "text": "For mer informasjon, se https://www.samsung.com/no/flex",
                            "url": "https://www.samsung.com/no/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Om Lisa&",
                    "text": "Firmanavn: Lisa & friends AB\nOrganisasjonsnummer: 559315-0955\nPostadresse: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden\nMomsregistreringsnummer: SE559315095501"
                },
                {
                    "title": "Om Samsung",
                    "text": "Firmanavnn: Samsung Electronics Nordic AB\nOrganisasjonsnummer: 556445-4345\nKontaktinformasjon: https://www.samsung.com/no/support/contact/\nBesøksadresse: Støperigata 2, 0 Oslo, Norge\nPostadresse: Box 1235, 164 28 Kista, Sweden\nMomsregistreringsnummer: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "plans": {
            "tradeInTitle": "Ytterligere rabatt etter innbytte:",
            "tradeIn": "{{amount}} / mnd i {{duration}} mnd",
            "closeModal": "Lukk",
            "selectSubscription": "Samsung Flex – den nye måten å ha en Samsung Galaxy på",
            "description": "Med Samsung Flex kan du ha en Samsung Galaxy uten å eie den, alltid til en fast månedskostnad. Du kan velge mellom friheten til å bytte, oppgradere og avslutte tjenesten når du vil, eller få en lavere månedskostnad med en avtaleperiode på 24 måneder. Når du oppgraderer eller avslutter, får din Samsung Galaxy et nytt liv eller blir resirkulert. Flex er et samarbeid mellom Samsung og Lisa& som gir deg mulighet til å leie enheter fra Lisa&.",
            "plans": {
                "EMPTY": {
                    "title": "-",
                    "description": "",
                    "descriptionOne": "",
                    "descriptionTwo": "",
                    "descriptionThree": ""
                },
                "FLEX": {
                    "title": "Full fleksibilitet",
                    "description": "",
                    "descriptionOne": {
                        "title": "Bytt, oppgrader og avslutt når du vil",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Tilgang til swap service",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "En fast månedlig kostnad",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "Full flexibilitet",
                        "paragraphs": [
                            {
                                "title": "Samsung Galaxy til en fast månedskostnad",
                                "content": "For en fast månedskostnad får du tilgang til en valgfri Samsung Galaxy-modell så lenge du måtte ønske."
                            },
                            {
                                "title": "Bytt eller oppgrader når du vil",
                                "content": "Det er enkelt å bytte eller oppgradere med Full Flex. Først bestiller du din nye Samsung Galaxy på samsung.com. Du får den nye enheten levert hjem sammen med en returetikett til den gamle enheten. \nDu trenger aldri å være uten din Samsung Galaxy."
                            },
                            {
                                "title": "Avslutt når du vil",
                                "content": "Når du har valgt å avslutte, sender Lisa&  en returetikett som du skal bruke til å sende tilbake enheten. Enheten må sendes til Lisa& senest 14 dager etter mottak av returetiketten. Hvis enheten ikke blir returnert innen angitt tid, regnes oppsigelsen som ugyldig og faktureringen for tjenesten gjenopptas inntil enheten mottas av Foxway."
                            },
                            {
                                "title": "Hvis enheten blir skadet",
                                "content": "Innenfor rammen av Samsung Flex får du tilbud om en såkalt Swap Service, som betyr at du for utilsiktede fall- og vannskader betaler en begrenset skadeavgift for en erstatningsenhet.\n\nDu melder skaden via kundeportalen, der Lisa& vurderer om skaden kvalifiserer for Swap Service. Ved godkjent skadesak vil Lisa& sende deg en erstatningsenhet sammen med et returkit til den skadde enheten. Den skadde enheten skal sendes til Lisa& innen 14 dager etter at du har mottatt erstatningsenheten.\n\n Hvis enheten blir stjålet, mistet eller ødelagt på annen måte enn hva som gjør den kvalifisert for Swap Service, plikter du å erstatte Lisa& for skaden som er forårsaket.  Lisa& forbeholder seg retten til å tilby en renovert erstatningsenhet. Fullstendige vilkår finner du på https://resellers.foxway.com/subscriptionterms-no."
                            },
                            {
                                "title": "Innbytte og rabatt",
                                "content": "Som ny Samsung Flex-kunde kan du velge å bytte inn din gamle telefon. Med Full Flex fordeles innbytteverdien og eventuelle ekstra rabatter over 12 måneder (eller lengre hvis rabatten er større enn 12 månedsavgifter). Rabatten overføres til den nye enheten ved oppgradering eller bytte av enhet."
                            },
                            {
                                "title": "Tilbehør",
                                "content": "Sammen med Samsung Flex kan du kjøpe tilbehør for maks. 5600 kroner. De kjøpes da av vår partner Lisa&."
                            }
                        ]
                    },
                    "priceDescription": "{{basePrice}} etter {{months}} måneder"
                },
                "VALUE": {
                    "title": "24 måneder",
                    "descriptionOne": {
                        "title": "Lavere månedlige kostnader med en avtale på 24 måneder (minimum bindingstid 12 måneder)",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Oppgrader eller lever den tilbake når avtalen løper ut",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "Tilgang til swap service",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "24 måneder",
                        "paragraphs": [
                            {
                                "title": "",
                                "content": "Med alternativet 24 måneder betaler du en lavere pris for å ha en Samsung Galaxy. Etter 24 måneder kan du oppgradere eller avslutte Samsung Flex."
                            },
                            {
                                "title": "Samsung Galaxy til en fast månedskostnad",
                                "content": "For en fast månedskostnad får du tilgang til en valgfri Samsung Galaxy-modell i 24 måneder."
                            },
                            {
                                "title": "Oppgrader eller avslutt etter 24 måneder",
                                "content": "Når avtaleperioden på 24 måneder nærmer seg slutten, blir du kontaktet for å velge et av alternativene. Det er enkelt å bytte eller oppgradere med Samsung Flex. Først bestiller du din nye Samsung Galaxy på samsung.com. Du får den nye enheten levert hjem sammen med en returetikett til den gamle enheten. Du trenger aldri å være uten din Samsung Galaxy når du oppgraderer.\n\nVelger du å avslutte tjenesten, får du bare tilsendt en returetikett. Enheten må sendes til Lisa&  senest 14 dager etter mottak av returetiketten. Hvis du ikke returnerer enheten, vil du bli belastet for skader tilsvarende enhetens markedsverdi på din siste faktura."
                            },
                            {
                                "title": "Avslutt før tiden",
                                "content": "Velger du å si opp avtalen før tiden (minste bindingstid 12 måneder), kan du ikke inngå en ny 24-måneders avtale før etter at den eksisterende avtalen ville ha utløpt (24 måneder fra avtalen ble inngått). Ved oppsigelse før tiden gjelder en 30-dagers oppsigelsesfrist. Dersom du sier opp avtalen før tiden må du for perioden du har hatt Enheten, etterbetale differansen mellom månedsprisen du har betalt for Flexavtalen med bindingstid og månedsprisen som gjelder for avtaler uten bindingstid.  Eventuelle rabatter utbetales ikke etter oppsigelse."
                            },
                            {
                                "title": "Hvis enheten blir skadet",
                                "content": "Innenfor rammen av Samsung Flex får du tilbud om en såkalt Swap Service, som betyr at du for utilsiktede fall- og vannskader betaler en begrenset skadeavgift for en erstatningsenhet.\n\nDu melder skaden via kundeportalen, der Lisa& vurderer om skaden kvalifiserer for Swap Service. Ved godkjent skadesak vil Lisa& sende deg en erstatningsenhet sammen med et returkit til den skadde enheten. Den skadde enheten skal sendes til Lisa& innen 14 dager etter at du har mottatt erstatningsenheten.\n\n Hvis enheten blir stjålet, mistet eller ødelagt på annen måte enn hva som gjør den kvalifisert for Swap Service, plikter du å erstatte Lisa& for skaden som er forårsaket.  Lisa& forbeholder seg retten til å tilby en renovert erstatningsenhet. Fullstendige vilkår finner du på https://resellers.foxway.com/subscriptionterms-no."
                            },
                            {
                                "title": "Innbytte og rabatt",
                                "content": "Som ny Samsung Flex-kunde kan du velge å bytte inn din gamle telefon. Med alternativet 24 måneder fordeles innbytteverdien og eventuelle ekstra rabatter over 24 måneder."
                            },
                            {
                                "title": "Tilbehør",
                                "content": "Sammen med Samsung Flex kan du kjøpe tilbehør for maks. 5600 kroner. De kjøpes da av vår partner Lisa&."
                            }
                        ]
                    }
                }
            },
            "selected": "Ditt valg",
            "select": "Velg",
            "minimumTotalCost": "Minste totalkostnad\n{{cost}}"
        },
        "sign": {
            "acceptTermsLabel": "Send meg markedsføringsmateriale",
            "acceptTerms": "Jeg samtykker til at Samsung Electronics Nordic AB sender meg informasjon om Samsungs produkter og tjenester. Informasjon om behandling av dine personopplysninger finner <1>du her</1>.",
            "acceptTermsLink": "https://www.samsung.com/no/info/privacy/",
            "title": "Personlig information",
            "firstName": "Fornavn",
            "lastName": "Etternavn",
            "email": "E-post",
            "phone": "Telefonnummer",
            "postalCode": "Postnummer",
            "address": "Adresse",
            "city": "Sted",
            "errors": {
                "firstName": "Ugyldig Fornavn",
                "lastName": "Ugyldig Etternavn",
                "lastNameTooBig": "Støtte for maksimalt 40 tegn. Vennligst fjern eventuelle mellomnavn og andre navn som ikke er i daglig bruk",
                "firstNameTooBig": "Støtte for maksimalt 40 tegn. Vennligst fjern eventuelle mellomnavn og andre navn som ikke er i daglig bruk",
                "email": "Ugyldig E-post",
                "phone": "Ugyldig Telefonnummer",
                "postalCode": "Ugyldig Postnummer",
                "address": "Ugyldig Adresse",
                "city": "Ugyldig Sted"
            },
            "steps": {
                "yourInfo": "Din info",
                "sign": "Signer",
                "confirmation": "Bekreftelse"
            },
            "delivery": "Levering",
            "differentShippingAddress": "Leveringsadressen min er forskjellig fra faktureringsadressen",
            "deliveryMethods": {
                "no-hd-parcel-bring-ce": {
                    "name": "Kostnadsfri hjemlevering med Bring",
                    "description": "",
                    "cartTitle": "Kostnadsfri hjemlevering med Bring",
                    "price": "Gratis"
                },
                "se-sena-hd-parcel-postnord": {
                    "name": "Hemleverans med Postnord",
                    "description": "Normal leveranstid är 1-5 vardagar, men kan vara längre för vissa postnummer.",
                    "cartTitle": "Hemleverans med Postnord",
                    "price": "Kostnadsfri"
                },
                "no-sena-hd-mxparcel-bring": {
                    "name": "Levering med Bring",
                    "description": "Normal leveringstid  er 1-5 virkedager",
                    "cartTitle": "Levering med Bring",
                    "price": "Gratis"
                },
                "no-sena-hd-parcel-dhl": {
                    "name": "Levering med DHL",
                    "description": "Normal leveringstid ved hjemlevering er 1-3 virkedager",
                    "cartTitle": "Levering med DHL",
                    "price": "Gratis"
                },
                "no-sena-pick-up-point": {
                    "name": "Levering med Bring",
                    "description": "Normal leveringstid  er 1-5 virkedager",
                    "cartTitle": "Levering med Bring",
                    "price": "Gratis"
                },
                "dk-sena-hd-parcel-postnord": {
                    "name": "Hjemmelevering (pakker) - Postnord",
                    "description": "Levering inden for 1-5 hverdage.\nDer kan være længere leveringstid ved levering til visse \npostnumre. \nTransportøren giver dig besked via SMS under transporten med \nanslået leveringsdato og -tidspunkt.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                },
                "fi-sena-hd-parcel-postnord": {
                    "name": "Kotiinkuljetus (paketti) – Postnord",
                    "description": "Toimitusaika 1-5 arkipäivää.\nToimitusaika saattaa olla pidempi tiettyjen postinumeroiden.\nLiikenteenharjoittajan tulee ilmoittaa sinulle tekstiviestitse \narvioitu toimituspäivä ja -aika kuljetukselle.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                }
            }
        },
        "authStep": {
            "title": "Logg inn med Bank-ID",
            "subtitle": "Logg inn på Flex-kontoen din med Bank-ID for å se Flex-enhetene dine og velge en enhet å oppgradere, eller legge til en enhet hvis du ønsker det.",
            "authenticationMethod": "Autentiseringsmetode",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "pepTerms": "Jeg bekrefter herved at jeg ikke er en politisk eksponert person (PEP), og at jeg ikke er et familiemedlem eller kjent medarbeider til en politisk eksponert person.",
            "loginWith": "Logg inn med Bank-ID"
        },
        "validationStep": {
            "title": "Kredittevaluering",
            "subtitle": "For at vi skal kunne behandle søknaden din, må vi foreta en kredittvurdering. Vennligst følg instruksjonene nedenfor for å fortsette.",
            "loadingText": "Vi kjører kredittvurderingen, det vil ta noen minutter. Vennligst vent, du vil automatisk bli omdirigert til neste trinn."
        },
        "creditCheckStep": {
            "title": "Behandling av fødselsnummer",
            "subtitle": "Inngåelse av Samsung Flex leieavtale forutsetter godkjennt kreditvurdering som gjøres basert på fødselsnumret ditt",
            "terms": "Jeg godtar at fødelsenumret mitt blir sent til Foxway´s leverandør Lisa& for kreditvurdering og dersom kontrakt signeres, oppsettning av månedlig fakturering for tjenesten Samsung Flex",
            "termsLink": "",
            "personalNumber": "Fødselsnummer",
            "errors": {
                "personalNumber": "Ugiltig fødselsnummer"
            }
        },
        "existingSubscriptionStep": {
            "title": "Din/dine Flex-enheter",
            "description": "Vil du oppgradere en eksisterende enhet eller legge til en ny?",
            "buttonText": "Legg til en ny Flex-enhet",
            "infoText": "",
            "flexTitle": "Full Fleksibilitet",
            "valueTitle": "24 måneder",
            "eligibleFrom": "Kan oppgradere fra: <bold>{{date}}</bold>",
            "planMismatchDisclaimer": "Can only be upgraded into <bold>{{name}}</bold>",
            "activeFrom": "Aktiv fra: <bold>{{date}}</bold>",
            "upgrade": "Oppgrader",
            "upgradeNotEligible": {
                "date": "Det er foreløpig ikke mulig å oppgradere. Se datoen ovenfor for når oppgradering er mulig.",
                "contactSupport": "Oppgradering er ikke mulig. Vennligst kontakt kundesupport.",
                "pendingUpgrade": "Dette abonnementet har allerede en signert oppgradering.",
                "activeClaim": "Det er ikke mulig å oppgradere på grunn av en pågående supportsak.",
                "deviceNotReturned": "Det er ikke mulig å oppgradere. Vi venter på en annen enhet fra deg.",
                "paymentPending": "Det er en ubetalt faktura for denne enheten. Du kan betale den her for å kunne oppgradere: ",
                "link": "lenke"
            }
        },
        "cart": {
            "disclaimer": "Innbytteverdien er et estimat. Rabatten fastslås og legges til når innbyttet er gjennomført.",
            "tradeInMonthlyEstimate": "Månedlig kostnad etter innbyte",
            "tradeInTitle": "Samsung Trade-in",
            "tradeInValue": "Innbytteverdi",
            "tradeInMonthlyDiscount": "Månedlig innbytterabatt i {{duration}} måneder",
            "prepayToday": "Beløb til betaling i dag",
            "prepay": "Betal {{months}} måned idag",
            "discountDuration": "rabatt i {{months}} måneder",
            "includesDiscount": "inkludert din rabatt på {{discount}}",
            "cart": "Handlevogn",
            "overview": "Oversikt",
            "oneTimeCost": "Engangskostnad",
            "oneTimeCostAccessories": "Engangskostnad - Tilbehør",
            "seeDetailsBelow": "Se detaljer nedenfor",
            "authentication": "Bekreft",
            "reviewAndSign": "Gjennomgå og signer",
            "continue": "Fortsett",
            "paymentMethod": "Betalingsmåte",
            "invoice": "Faktura",
            "minimumTotalCost": "Minste totalkostnad",
            "monthlyCost": "Månedlig kostnad",
            "monthlyCostWithoutDiscount": "Månedlig pris før rabatt",
            "generalDiscount": "Rabatt",
            "specialPriceTitle": "De første {{specialPriceLength}} månedene, deretter {{priceGross}} {{currencyMonthly}}",
            "creditCheck": "Kjør kredittsjekk",
            "fraudProtection": "Vennligst vent",
            "emptyText": "Velg abonnementstype først.",
            "noticeText": "Ved å legge til min betalingsmåte godtar jeg at Lisa& automatisk og på forhånd kan belaste alle kostnader som skal betales til Lisa&."
        },
        "currency": {
            "perMonth": "mnd",
            "feeForMonths": "{{fee}} i {{months}} mnd"
        },
        "errorPages": {
            "accessory": {
                "title": "Den høyeste samlede tilbehørskostnaden er overskredet.",
                "button": "Tilbake til handlekurven",
                "content": "<1><2>Sammen med din Samsung Flex-enhet kan du kjøpe andre produkter for maks. 5600 kroner. Du har tilbehør i handlekurven som overstiger dette beløpet, og må derfor legge inn en separat bestilling med en annen betalingsmåte for disse.</2></1>"
            },
            "general": {
                "title": "Noe gikk galt",
                "button": "Tilbake til handlekurven",
                "content": "<1><2>Noe gikk galt. Prøv igjen</2></1>"
            },
            "auth": {
                "title": "Noe gikk galt",
                "button": "Tilbake til handlekurven",
                "content": "<1><2>Noe gikk galt. Prøv igjen</2></1>"
            },
            "creditCheck": {
                "title": "Kredittsjekk Ikke godkjent",
                "button": "Tilbake til handlekurven",
                "contentFailed": "Din søknad har blitt avvist da den ikke oppfyller vår finansieringspartners kriterier for dette produktet. For mer informasjon er du velkommen til å kontakte vår kundestøtte.",
                "contentTryAgain": "Søknaden din har blitt avslått fordi banken eller kontoen du valgte ikke ser ut til å være din hovedkonto. Gå tilbake og søk med din primære bankkonto."
            }
        },
        "errors": {
            "generic": "Noe gikk galt. Prøv igjen",
            "authenticationError": "Uautorisert tilgang",
            "nicknameChangeError": "Nickname must be between 1 and 40 characters",
            "scrive": {
                "authenticationError": "Noe gikk galt med autentiseringen. Prøv igjen."
            },
            "svea": {
                "general": "",
                "underAge": "",
                "overAge": "",
                "numberOfAllowedSubscriptions": ""
            }
        },
        "portal": {
            "fraudulentCustomer": "Du har ubetalte fakturaer.",
            "payingIssuesCustomer": "Du har ubetalte fakturaer.",
            "dashboard": {
                "title": "Velkommen, "
            },
            "invoiceStatus": {
                "due": "Ubetalt",
                "allPaid": "Alt er betalt!",
                "dueOn": "Neste faktura må betales innen: <2>{{date}}</2>.",
                "nextPayment": "Neste faktura må betales innen: <2>{{date}}</2>.",
                "noNextPayment": "Ingen neste betaling",
                "button": "Vis fakturaer"
            },
            "products": {
                "nickname": "{{firstName}}s enhet"
            },
            "invoice": {
                "status": {
                    "outstanding": "Ubetalt",
                    "partiallyPaid": "Delvis betalt",
                    "paid": "Alt er betalt!",
                    "terminated": "Avsluttet",
                    "unknown": "Ukjent",
                    "credited": "Kreditert"
                }
            },
            "invoices": {
                "title": "Fakturaer",
                "tableHeader": ["Faktura-ID", "Beskrivelse", "Periode", "Forfallsdato: ", "Sum", "Status"],
                "viewInvoice": "Vis faktura",
                "viewInvoices": "Se fakturaer",
                "loadMore": "Last mer",
                "accordion": {
                    "title": "Hvordan oppretter jeg autogiro?",
                    "text": "Opprett betaling via eFaktura eller avtalegiro i nettbanken din. "
                },
                "status": {
                    "outstanding": "Forsinket",
                    "partiallyPaid": "Delvis betalt",
                    "paid": "Betalt",
                    "terminated": "Avsluttet",
                    "unknown": "Ukjent"
                },
                "noInvoices": "Ingen fakturaer"
            },
            "billingAlert": {
                "generic": {
                    "before": "Betalingsmåten din er i ferd med å utløpe. ",
                    "link": "Oppdater betalingsmåte",
                    "after": ""
                },
                "detailed": {
                    "before": "Betalingsmåten din er i ferd med å utløpe. For å kunne fortsette å bruke tjenestene våre etter {{dueDate}}, vennligst ",
                    "link": "oppdater betalingsmåten din",
                    "after": "."
                }
            }
        },
        "profile": {
            "title": "Min konto",
            "contactInformation": {
                "title": "Kontaktopplysninger",
                "firstName": "Fornavn",
                "lastName": "Etternavn",
                "email": "E-post",
                "phone": "Telefon"
            },
            "billingInformation": {
                "title": "Faktureringsopplysninger",
                "card": "Kort",
                "expires": "Utløper",
                "updatePaymentMethod": "Oppdater betalingsmetode",
                "methodUpdateDescription": "Oppdatering av betalingsmåte",
                "noInfo": "Ingen faktureringsopplysninger tilgjengelig"
            },
            "address": {
                "title": "Adresse",
                "postalCode": "Postnummer",
                "address": "Adresse",
                "city": "Sted",
                "saveButton": "Lagre adresse"
            },
            "notificationPreferences": {
                "marketingModal": {
                    "title": "Send meg markedsføringsmateriale",
                    "content": "eg samtykker til at Samsung Electronics Nordic AB sender meg informasjon om Samsungs produkter og tjenester.  For informasjon om behandlingen av dine personopplysninger, se <a href=\"https://www.samsung.com/no/info/privacy/\">her</a>"
                },
                "title": "Varslinger",
                "marketingEmails": "Markedsføring",
                "marketingEmailsLabel": "Send meg markedsføringsmateriale og spesialtilbud"
            },
            "contactInformationDisclaimer": {
                "title": "Dine kontaktopplysninger",
                "card": {
                    "title": "Dine kontaktopplysninger",
                    "description": "Dine kontaktopplysninger ble registrert i forbindelse med ordren. Kontakt kundeservice ved behov for å oppdatere opplysningene.\n21 62 90 97",
                    "link": "",
                    "linkUrl": ""
                }
            }
        },
        "offers": {
            "title": "Tilbud"
        },
        "upgrade": {
            "title": "Oppgrader"
        },
        "faq": {
            "title": "Frequently Asked Questions",
            "items": [
                {
                    "id": "samsung-flex",
                    "label": "What is Samsung Flex",
                    "children": "Samsung Flex is a service for you who would rather have a fixed monthly cost and regularly keep yourself updated instead of buying your Samsung Galaxy separately. Samsung Flex is available in two variants, Full Flexibility which gives you the freedom to change, upgrade or terminate whenever you want or 24 months where you pay a lower monthly cost and have your phone a little longer. Access to swap service applies to both."
                },
                {
                    "id": "samsung-flex-vs-buying",
                    "label": "How is Samsung Flex different from buying a device outright or in installments?",
                    "children": "..."
                }
            ]
        },
        "subscription": {
            "tradeInReimbursement": "Tilbakebetaling av gjenværende innbyttesaldo",
            "flexSubscriptionFee": "Flex-abonnement",
            "depositAndAccessoryPayment": "Depositum og betaling av tilbehør",
            "upfrontPayment": "Betaling for første {{months}} måneder & tilbehør",
            "endedDate": "Sluttdato",
            "upgradeFrom": "Kan oppgraderes fra <1></1>",
            "ended": "Endte",
            "contractSigned": "Kontrakt signert",
            "contractStarted": "Abonnement startet",
            "contractEnded": "Abonnementet er avsluttet",
            "upgradeAnyTime": "Oppgrader når du vil",
            "addNewSubscriptionLink": "https://shop.samsung.com/nb/",
            "devicesTitle": "Mine tidligere enheter",
            "flexTitle": "Dine enheter med Full Flex",
            "imeiCopy": "IMEI kopiert",
            "viewContract": "Se avtale",
            "viewInvoices": "Vis fakturaer",
            "manageSubscription": "Håndter min enhet",
            "addNewSubscription": "Legg til ny enhet",
            "swapService": "Swap Service",
            "insuranceService": "Opprett en forsikringssak",
            "deviceDamagedConditionTermsLink": "https://resellers.foxway.com/subscriptionterms-no",
            "deviceDamagedConditionTerms": "<0>Hvis enheten skades eller blir borte, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du et begrenset skadegebyr for å få en erstatningsenhet. Gebyret varierer avhengig av modell. Svar på spørsmålene nedenfor for å beskrive saken og få Foxways vurdering av hvorvidt skaden kvalifiserer for en Swap Service. Hvis skaden kvalifiserer for Swap Service, vil Foxway sende deg en erstatningsenhet sammen med et returkit som du bruker til å returnere den skadde enheten. Vær oppmerksom på at den skadde enheten må returneres innen 14 dager fra du mottar erstatningsenheten. Unnlater du å returnere den skadde enheten, vil Foxway fakturere deg for erstatningsenheten i henhold til avtale. Se fullstendige vilkår for Swap Service <2>her</2></0>",
            "subscriptionsTitle": "Mine enheter",
            "valueTitle": "Dine enheter med 24 mnd",
            "nickname": {
                "title": "Endre navn",
                "nickname": "Navn",
                "description": "Du kan legge til en kort beskrivelse for en enhet, slik at du kan skille mellom enhetene hvis du har flere. Du kan gi dem et hvilket som helst navn, for eksempel “Lasses mobil”."
            },
            "payPendingPayment": "Betal",
            "pendingPaymentsTitle": "Venter",
            "tags": {
                "upgradeTo": "Oppgraderer til",
                "upgradeFor": "Oppgrader for",
                "beingDelivered": "Blir levert",
                "pendingPayemnt": "Signert, men betaling venter"
            },
            "cancel": {
                "title": "Avslutt Samsung Flex",
                "bolttech": {
                    "title": "Avslutt Samsung Flex",
                    "deviceDamagedConditionTerms": "<0>Hvis enheten blir skadet eller forsvinner, må du søke erstatning hos Lisa& for skaden som har oppstått. I Samsung Flex er forsikringen Samsung Care+ inkludert, og den dekker utilsiktede fall- og vannskader. Da skal det opprettes en forsikringssak. For enkelte andre typer skader kan Samsungs garanti gjelde.</0><1>Fyll ut skjemaet for å få hjelp til å finne den beste løsningen på problemet ditt.</1>",
                    "submitButton": "Fortsett",
                    "continueButton": "Fortsett",
                    "fellAndBrokeNotificationTitle": "Skaden din er av en type som normalt dekkes av Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Gå videre for å opprette en forsikringssak hos forsikringsselskapet.",
                    "stoppedWorkingNotificationTitle": "Ditt problem täcks inte av försäkringen, men kan omfattas av garantin.",
                    "stoppedWorkingNotificationContent": "Kontakta vår support för mer information.",
                    "lostOrStolenNotificationTitle": "Förlust av enhet täcks inte av försäkringen.",
                    "lostOrStolenNotificationContent": "Kontakta vår support för mer information.",
                    "damageSpecTitle": "Vennligst last opp bilder som viser enhetens tilstand",
                    "specificDamage": {
                        "frontScreen": "Forsiden",
                        "frontScreenDescription": "Last opp bilde(r) som viser enhetens forside og hovedskjerm",
                        "backSide": "Baksiden",
                        "backSideDescription": "Last opp bilde(r) som viser enhetens bakside"
                    }
                },
                "unavailableNotification": {
                    "title": "Kanseller bestillingen din",
                    "content": "Bestillingen din kan ikke kanselleres på dette tidspunktet. Kontakt vår kundestøtte for mer informasjon.",
                    "linkText": "",
                    "linkUrl": "",
                    "automaticClaim": "Ditt Samsung Flex-avtale løper snart ut. Vi har allerede startet den automatiske oppsigelsen, og du bør få et retursett snart. Vil du oppgradere til en ny enhet? Gå til Samsung.com og bestill din nye enhet. Velg å oppgradere din eksisterende enhet under utsjekkingen. Hvis du ønsker å beholde enheten, vennligst kontakt vår support for et utkjøpstilbud."
                },
                "receipt": {
                    "title": "Swap Service med saks-ID {{id}} er registrert",
                    "content": "Du kan se status for pågående Swap Service under Mine enheter\nNår saken er behandlet, får du tilsendt en erstatningsenhet sammen med et returkit som du bruker til å returnere den skadde enheten til Foxway, som tar hånd om den på best mulig måte.\nHusk:\n1. Tilbakestill om mulig enheten til fabrikkinnstillinger, slett all informasjon og fjern Google-kontoen din fra den skadde enheten\n2. Den skadde enheten må returneres innen 14 dager fra du mottar erstatningsenheten. Unnlater du å returnere enheten, kan Foxway fakturere deg for erstatningsenhetens markedsverdi.",
                    "button": "Tilbake til startsiden"
                },
                "keepDisclaimerTitle": "Jeg vil levere tilbake enheten",
                "keepDisclaimerContent": "Hvis du vil beholde enheten din, bør du kontakte kundestøtte.",
                "upgradeDisclaimerLink": "Administrer dette abonnementet",
                "upgradeDisclaimerTitle": "Vil du oppgradere til en ny enhet?",
                "upgradeDisclaimerContent": "Hvis du vil oppgradere enheten din, må du gå tilbake til siden for abonnementsadministrasjon.",
                "stateChoice": {
                    "title": "Vil du beholde, returnere eller oppgradere enheten?",
                    "returnDevice": "Jeg vil levere tilbake enheten",
                    "keepDevice": "Jeg vil beholde enheten min",
                    "upgradeDevice": "Jeg vil oppgradere enheten"
                },
                "invoicesDisclaimerTitle": "Utestående fakturaer",
                "invoicesDisclaimerContent": "Du har ubetalte fakturaer, vær oppmerksom på at alle fakturaer må betales før kanselleringen er fullført.",
                "errors": {
                    "frontSideDamageFiles": "Last opp et bilde av fronten av enheten",
                    "backSideDamageFiles": "Last opp et bilde av baksiden av enheten"
                },
                "claimStatus": {
                    "pending": "Avbestilling sendt",
                    "approved": "Avbestilling godkjent",
                    "declined": "Avbestilling avvist",
                    "completed": "Avbestilling fullført",
                    "sent": "Retursett sendt",
                    "waitingForPayment": "Har utestående fakturaer",
                    "paymentReceived": "Payment received",
                    "deviceReceived": "Enhet mottatt",
                    "deviceReceivedDamaged": "Enhet mottatt skadet"
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Vil du avslutte Samsung Flex?",
                        "content": [
                            "Med Full Flex kan du si opp avtalen når som helst. Tjenesten avsluttes den siste dagen i den måneden du sier opp, og du betaler for tjenesten ut måneden. Du får tilsendt et returkit som du skal bruke til å returnere enheten. Når måneden er omme, har du 14 dager på deg til å levere tilbake enheten.\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din fra enheten før du sender den inn.</li><li>Ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppsigelse.</li><li>Hvis enheten er skadet, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du et begrenset skadegebyr.</li><li>Fakturering gjenopptas for enheten hvis den ikke blir returnert innen 14 dager etter at inneværende måned ved oppsigelsestidspunktet er utløpt.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med Full Flex kan du si opp avtalen når som helst. Tjenesten avsluttes den siste dagen i den måneden du sier opp, og du betaler for tjenesten ut måneden. Du får tilsendt et returkit som du skal bruke til å returnere enheten. Når måneden er omme, har du 14 dager på deg til å levere tilbake enheten.\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din fra enheten før du sender den inn.</li><li>Ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppsigelse.</li><li>Enheten skal leveres tilbake i god stand, der normal slitasje er akseptert. Dersom enheten blir skadet, må du søke erstatning hos Lisa& for skaden som har oppstått. Utilsiktede fall- og vannskader dekkes av den medfølgende forsikringen, og det skal da opprettes en forsikringssak for vurdering hos forsikringsselskapet. Følg instruksjonene i neste steg for å gå videre. </li><li>Fakturering gjenopptas for enheten hvis den ikke blir returnert innen 14 dager etter at inneværende måned ved oppsigelsestidspunktet er utløpt.</li></ul>"
                            ]
                        },
                        "action": "Avslutt tjenesten",
                        "stepsTitle": "Slik fungerer det, steg for steg",
                        "steps": [
                            "Klikk på Avslutt og følg instruksjonene. Du må nå svare på noen spørsmål om enhetens tilstand.",
                            "Når oppsigelsen av tjenesten er fullført, sender vi deg et returkit.",
                            "Slett all informasjon og fjern Google-kontoen din fra den gamle enheten.",
                            "Pakk den gamle enheten omhyggelig inn og lever den til nærmeste postekspedisjonssted."
                        ],
                        "eligibleNotificationText": "For å kansellere kontrakten din i løpet av de første {{days}} dagene, vennligst kontakt Samsung."
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Vil du avslutte Samsung Flex?",
                        "content": [
                            "Med 24 mnd kan du velge å oppgradere og inngå en ny avtale innenfor rammen av Samsung Flex, eller avslutte tjenesten. Du kan gjøre valget her i kundeportalen en måned før avtaleperiodens utløp. Hvis du ikke gjør et akivt valg, avsluttes tjenesten automatisk og du må returnere enheten. Når enheten skal leveres tilbake, sender Foxway deg et returkit som du bruker til å returnere enheten.\nØnsker du å avslutte før tiden, har du rett til å si opp avtalen med 30 dagers varsel, med minste bindingstid 12 måneder. Vær oppmerksom på at eventuelle ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppsigelse, at du ikke kan inngå en ny avtale med 24 måneder før avtalen skulle ha utløpt, samt at eventuelle ubenyttede rabatter ikke vil bli refundert. Kontakt kundeservice hvis du ønsker tidlig oppsigelse, så hjelper vi deg.\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din</li><li>Hvis enheten er skadd, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du bare et begrenset skadegebyr.</li><li>Hvis enheten ikke blir returnert innen 14 dager etter avtaleperiodens utløp, vil du bli fakturert for et gebyr som kompensasjon til Foxway for enheten som ikke er levert tilbake.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med 24 måneder kan du velge å oppgradere eller avslutte tjenesten ved slutten av avtaleperioden. Hvis du ikke gjør et aktivt valg, avsluttes tjenesten automatisk, og du må returnere enheten. Når enheten skal returneres, sender Foxway deg et returkit som du bruker til å sende den tilbake. Kontakt kundeservice hvis du ønsker å avslutte avtalen tidligere.\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din</li><li>Enheten skal leveres tilbake i god stand, der normal slitasje er akseptert. Dersom enheten blir skadet, må du søke erstatning hos Lisa& for skaden som har oppstått. Utilsiktede fall- og vannskader dekkes av den medfølgende forsikringen, og det skal da opprettes en forsikringssak for vurdering hos forsikringsselskapet. Følg instruksjonene i neste steg for å gå videre.</li><li>Hvis enheten din ikke er returnert innen 14 dager etter at avtaleperioden er utløpt, vil du bli fakturert et gebyr som kompensasjon for manglende retur. </li></ul>"
                            ]
                        },
                        "action": "Avslutt tjenesten",
                        "stepsTitle": "Slik fungerer det",
                        "steps": [
                            "Klikk på Avslutt tjenesten og følg instruksjonene. Det er mulig å gjøre valget én måned før avtaleperiodens utløp.",
                            "Har du valgt å avslutte og returnere (eller ikke gjort noe valg), vil du få tilsendt et returkit. Ta kontakt med oss hvis du ikke har mottatt den ved avtaleperiodens utløp.",
                            "Slett all informasjon og fjern Google-kontoen din.",
                            "Pakk enheten omhyggelig inn og lever den til nærmeste postekspedisjonssted."
                        ],
                        "eligibleNotificationText": "For å kansellere kontrakten din i løpet av de første {{days}} dagene, vennligst kontakt Samsung."
                    }
                },
                "disclaimer": {
                    "flex": {
                        "title": "Husk følgende når du avslutter Samsung Flex, Full Flex:",
                        "content": [
                            "Tilbakestill enheten til fabrikkinnstillinger, slett all informasjon og fjern Google-kontoen din",
                            "Ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppsigelse.",
                            "Hvis enheten er skadet, stjålet eller blitt borte, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du bare et begrenset skadegebyr.",
                            "Fakturering gjenopptas for enheten hvis den ikke blir returnert innen 14 dager etter at inneværende måned ved oppsigelsestidspunktet er utløpt."
                        ],
                        "bolttech": {
                            "content": [
                                "Tilbakestill enheten til fabrikkinnstillinger, slett all informasjon og fjern Google-kontoen din",
                                "Ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppsigelse.",
                                "Dersom enheten er skadet, stjålet eller forsvunnet, må du søke erstatning hos Lisa& for skaden som har oppstått. Samsung Flex inkluderer en forsikring som dekker vann- og ulykkesskader. Følg instruksjonene for å fullføre oppsigelsen og registrere en forsikringssak dersom du har en slik skade.",
                                "Fakturering gjenopptas for enheten hvis den ikke blir returnert innen 14 dager etter at inneværende måned ved oppsigelsestidspunktet er utløpt."
                            ]
                        }
                    },
                    "value": {
                        "title": "Husk følgende når du avslutter din Samsung Flex 24 måneder:",
                        "content": [
                            "Tilbakestill enheten til fabrikkinnstillinger, slett all informasjon og fjern Google-kontoen din fra enheten før du sender den inn",
                            "Hvis enheten er skadet eller blitt borte, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du bare et begrenset skadegebyr. Se fullstendige vilkår.",
                            "Hvis enheten ikke blir returnert innen 14 dager etter avtaleperiodens utløp, vil du bli fakturert for et gebyr som kompensasjon til Foxway for enheten som ikke er levert tilbake."
                        ],
                        "bolttech": {
                            "content": [
                                "Tilbakestill enheten til fabrikkinnstillinger, slett all informasjon og fjern Google-kontoen din fra enheten før du sender den inn",
                                "Dersom enheten er skadet, stjålet eller forsvunnet, må du søke erstatning hos Lisa& for skaden som har oppstått. Samsung Flex inkluderer en forsikring som dekker vann- og ulykkesskader. Følg instruksjonene for å fullføre oppsigelsen og registrere en forsikringssak dersom du har en slik skade.",
                                "Hvis enheten ikke blir returnert innen 14 dager etter avtaleperiodens utløp, vil du bli fakturert for et gebyr som kompensasjon til Foxway for enheten som ikke er levert tilbake."
                            ]
                        }
                    }
                },
                "noDamageDescription": "",
                "hasDamageDescription": "",
                "formTitle": "Vi trenger flere opplysninger før du avslutter",
                "conditionChoice": "Er enheten i god stand?",
                "conditionsButton": "Vis mer",
                "noDamage": "Ja, enheten er i god stand, fungerer og har ingen skader. Normal slitasje og kosmetiske skader, for eksempel riper som ikke påvirker funksjonaliteten, regnes ikke som skader.",
                "hasDamage": "Nei, enheten er skadet, alternativt stjålet eller blitt borte",
                "damageTitle": "Beskriv hva som har skjedd med enheten",
                "damageAdditionalTitle": "Ha bilder av skadene klare (forside, bakside, åpen). Du vil bli bedt om å laste dem opp nedenfor.",
                "damageDate": "Når skjedde skaden?",
                "damageDatePlaceholder": "Velg dato",
                "nextMonth": "Neste måned",
                "prevMonth": "Forrige måned",
                "damageDescription": "Beskriv hva som har skjedd med enheten",
                "damageDescriptionPlaceholder": "Beskriv hva som har skjedd med enheten",
                "damageSpecTitle": "Velg beskrivelsen som passer best til skaden. Du kan velge flere alternativer.",
                "termsLabel": "Jeg har lest og forstått ovennevnte informasjon",
                "submitButton": "Bekreft",
                "damageType": {
                    "placeholder": "Velg et alternativ",
                    "fellAndBroke": "Enheten har en utilsiktet fall- eller vannskade",
                    "stoppedWorking": "Enheten har sluttet å fungere eller har en annen teknisk feil som har oppstått utilsiktet",
                    "lostOrStolen": "Enheten er blitt stjålet eller mistet"
                },
                "specificDamage": {
                    "frontScreen": "Skjermskade - hovedskjerm",
                    "frontScreenDescription": "Hovedskjermen (den største skjermen hvis enheten har flere skjermer) har én eller flere sprekker (ripe regnes ikke som skade).",
                    "frontScreenAddFile": "Last opp bilder",
                    "frontScreenFile": "Skjermskade - hovedskjerm",
                    "frontScreenRemove": "Fjern bilder på frontskjermen",
                    "backSide": "Skade på bakside og/eller ramme",
                    "backSideDescription": "Baksiden og/eller rammen er sprukket eller bøyd. (Ripe regnes ikke som skade)",
                    "backSideAddFile": "Last opp bilder",
                    "backSideFile": "Skade på bakside og/eller ramme",
                    "backSideRemove": "Fjern bakskjermbildet",
                    "camera": "Skadet kamera",
                    "cameraDescription": "Kameraet har en sprekk, ripe eller annen skade som påvirker kamerafunksjonen. (ripe eller annen skade som ikke påvirker kamerafunksjonen, regnes ikke som skade)",
                    "audio": "Lydproblem",
                    "audioDescription": "Mikrofonen eller høyttaleren fungerer ikke, problemer med lydforvrengning",
                    "network": "Nettverksproblem",
                    "networkDescription": "Enheten har problemer med å koble til nettverket",
                    "power": "PÅ/AV-problem",
                    "powerDescription": "Kan ikke slå enheten på eller av",
                    "other": "Annen",
                    "otherDescription": "Enheten har en annen type skade",
                    "otherDescriptionLabel": "Vennligst beskriv skaden i detalj",
                    "otherDescriptionPlaceholder": "Beskriv skaden"
                },
                "upsell": {
                    "title": "Er du sikker på at du vil avslutte?",
                    "content": "Ønsker du å bytte ut enheten, finnes det andre muligheter.",
                    "options": {
                        "swap-device": "Jeg vil oppgradere enheten",
                        "cancel-sub": "Jeg vil avslutte tjenesten",
                        "upgrade-device": "Jeg vil melde en skade og fortsette å bruke Samsung Flex"
                    },
                    "confirmButton": "Bekreft",
                    "closeButton": "Lukk"
                },
                "notSupportedNotificationTitle": "Stjålne eller tapte enheter er ikke kvalifisert for kansellering",
                "notSupportedNotificationContent": "Kontakt vår kundestøtte for mer informasjon.",
                "warrantyNotificationTitle": "Ser ut til at problemet ditt er dekket av garantien",
                "warrantyNotificationContent": "Kontakt vår kundestøtte for mer informasjon."
            },
            "upgrade": {
                "unavailableNotification": {
                    "title": "Oppgrader abonnementet ditt",
                    "content": "For mer informasjon, kontakt Samsung kundestøtte.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Vil du oppgradere eller bytte til en ny enhet?",
                        "action": "Oppgrader",
                        "url": "https://samsung.com",
                        "content": [
                            "Med Full Flex kan du oppgradere eller bytte enhet når du vil. Velg din nye enhet på samsung.com og bestill den med Samsung Flex. I neste steg velger du å oppgradere din eksisterende Samsung Flex-tjeneste. Når bestillingen er gjort, inngå du en ny avtale innenfor rammen for Samsung Flex, og du får din nye enhet levert hjem sammen med en returfraktseddel som du skal bruke til å sende tilbake den gamle enheten. Da kan du overføre alt innhold til den nye enheten før du sender tilbake den gamle. Du vil bli fakturert for den nye enheten straks du mottar den\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din før du sender inn enheten</li><li>Ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppgradering når du inngår en ny avtale. Eventuell rabatt for innbytteenheten blir derimot videreført til den nye avtalen.</li><li>Hvis enheten er skadet, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du et begrenset skadegebyr.</li><li>Fakturering gjenopptas for din nåværende enhet hvis den ikke blir returnert innen 14 dager fra du mottok din nye enhet.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med Full Flex kan du oppgradere eller bytte enhet når du vil. Velg din nye enhet på samsung.com og bestill den med Samsung Flex. I neste steg velger du å oppgradere din eksisterende Samsung Flex-tjeneste. Når bestillingen er gjort, inngå du en ny avtale innenfor rammen for Samsung Flex, og du får din nye enhet levert hjem sammen med en returfraktseddel som du skal bruke til å sende tilbake den gamle enheten. Da kan du overføre alt innhold til den nye enheten før du sender tilbake den gamle. Du vil bli fakturert for den nye enheten straks du mottar den\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din før du sender inn enheten</li><li>Ubenyttede rabatter i din nåværende Samsung Flex-avtale opphører ved oppgradering når du inngår en ny avtale. Eventuell rabatt for innbytteenheten blir derimot videreført til den nye avtalen.</li><li>Enheten skal leveres tilbake i god stand, der normal slitasje er akseptert. Dersom enheten blir skadet, må du søke erstatning hos Lisa& for skaden som har oppstått. Utilsiktede fall- og vannskader dekkes av den medfølgende forsikringen, og det skal da opprettes en forsikringssak for vurdering hos forsikringsselskapet. Enkelte andre typer skader kan være dekket av Samsungs garanti. </li><li>Fakturering gjenopptas for din nåværende enhet hvis den ikke blir returnert innen 14 dager fra du mottok din nye enhet.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Slik oppgraderer du steg for steg",
                        "steps": [
                            "Klikk på `Oppgrader` og velg din nye enhet på samsung.com.",
                            "Legg til Samsung Flex og gå til kassen. Velg det alternativ for Samsung Flex som skal gjelde for din nye enhet.",
                            "Når du identifiserer deg, får du som eksisterende kunde spørsmål om du vil oppgradere en nåværende enhet. Velg enheten som du vil oppgradere.",
                            "Fullfør bestillingen og få din nye enhet levert hjem sammen med en returfraktseddel for den gamle enheten.",
                            "Overfør alt innhold til den nye enheten. Slett deretter all informasjon og fjern Google-kontoen din fra den gamle enheten.",
                            "Pakk den gamle enheten omhyggelig inn og lever den til nærmeste postekspedisjonssted. Du kan bruke samme emballasje som den nye enheten kom i."
                        ]
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Vil du oppgradere til en ny enhet?",
                        "action": "Oppgrader",
                        "url": "https://samsung.com",
                        "content": [
                            "Er det på tide å oppgradere? Med 24 mnd kan du oppgradere til en ny enhet når avtaleperioden utløper. Det gjør du ved å velge din nye enhet på samsung.com og bestille den med Samsung Flex. I neste steg velger du å oppgradere din eksisterende Samsung Flex-tjeneste. Det kan du gjøre fra og med datoen da én måned av avtaleperioden gjenstår.\nNår du har fullført bestillingen, får du tilsendt din nye enhet sammen med en returfraktseddel som du skal bruke  til å sende tilbake den gamle enheten. Da kan du overføre alt innhold til den nye enheten før du sender tilbake den gamle.\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din</li><li>Hvis enheten er skadd, må du betale Foxway for skaden som er forårsaket. For utilsiktede fall- og vannskader betaler du bare et begrenset skadegebyr.</li><li>Hvis enheten ikke blir returnert innen 14 dager etter avtaleperiodens utløp, vil du bli fakturert for et gebyr som kompensasjon til Foxway for enheten som ikke er levert tilbake.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Er det på tide å oppgradere? Med 24 mnd kan du oppgradere til en ny enhet når avtaleperioden utløper. Det gjør du ved å velge din nye enhet på samsung.com og bestille den med Samsung Flex. I neste steg velger du å oppgradere din eksisterende Samsung Flex-tjeneste. Det kan du gjøre fra og med én måned før avtaleperioden avsluttes.\nNår du har fullført bestillingen, får du tilsendt din nye enhet sammen med en returfraktseddel som du skal bruke  til å sende tilbake den gamle enheten. Da kan du overføre alt innhold til den nye enheten før du sender tilbake den gamle.\n\nHusk:\n<ul><li>Å tilbakestille enheten til fabrikkinnstillinger, slette all informasjon og fjerne Google-kontoen din</li><li>Enheten skal leveres tilbake i god stand, der normal slitasje er akseptert. Dersom enheten blir skadet, må du søke erstatning hos Lisa& for skaden som har oppstått. Utilsiktede fall- og vannskader dekkes av den medfølgende forsikringen, og det skal da opprettes en forsikringssak for vurdering hos forsikringsselskapet. Enkelte andre typer skader kan være dekket av Samsungs garanti. </li><li>Hvis enheten ikke blir returnert innen 14 dager etter avtaleperiodens utløp, vil du bli fakturert for et gebyr som kompensasjon til Foxway for enheten som ikke er levert tilbake.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Slik oppgraderer du, steg for steg",
                        "steps": [
                            "Sjekk avtaleperioden. Med 24 måneder kan du bestille en oppgradering fra én måned før utløpet av avtaleperioden.",
                            "Klikk på 'Oppgrader' og velg din nye enhet på samsung.com.",
                            "Når du identifiserer deg, får du som eksisterende kunde spørsmål om du vil oppgradere en nåværende enhet. Velg enheten som du vil oppgradere.",
                            "Fullfør bestillingen og få din nye enhet levert hjem sammen med en returfraktseddel for den gamle enheten.",
                            "Overfør alt innhold til den nye enheten. Slett deretter all informasjon og fjern Google-kontoen din fra den gamle enheten.",
                            "Pakk den gamle enheten omhyggelig inn og lever den til nærmeste postekspedisjonssted. Du kan bruke samme emballasje som den nye enheten kom i."
                        ]
                    }
                }
            },
            "swap": {
                "unavailableNotification": {
                    "title": "Swap Service er ikke tilgjengelig.",
                    "content": "For mer informasjon, kontakt Samsung kundestøtte.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "receipt": {
                    "title": "Swap Service med saks-ID {{id}} er registrert",
                    "content": "Når saken din er behandlet, og hvis den er godkjent, vil du motta en faktura med byttekostnaden. (Hvis du har direkte belastning aktivert, vil kostnaden bli trukket fra kontoen din automatisk). Så snart betalingen er utført, vil en erstatningsenhet bli sendt til deg sammen med et retursett som du bruker til å sende den skadede enheten tilbake til Foxway.",
                    "button": "Tilbake Hjem"
                },
                "paymentSuccess": {
                    "title": "Swap Service-sak {{id}} er nå opprettet og betalt",
                    "content": "Du kan se dine pågående Swap Service-saker og deres status under <1>Mine Enheter</1><2>Din sak vil bli behandlet innen 2 arbeidsdager.</2>",
                    "button": "Tilbake Hjem"
                },
                "paymentError": {
                    "title": "Swap Service-sak {{id}} er nå opprettet men betalingen mislyktes",
                    "content": "Fullfør betalingen for å fullføre Swap-Service",
                    "button": "Betale"
                },
                "title": "Swap Service",
                "bolttech": {
                    "title": "Opprett forsikringssak",
                    "deviceDamagedConditionTerms": "<0>Hvis enheten blir skadet eller forsvinner, må du søke erstatning hos Lisa& for skaden som har oppstått. I Samsung Flex er forsikringen Samsung Care+ inkludert, og den dekker utilsiktede fall- og vannskader. Da skal det opprettes en forsikringssak. For enkelte andre typer skader kan Samsungs garanti gjelde.</0><1>Fyll ut skjemaet for å få hjelp til å finne den beste løsningen på problemet ditt.</1>",
                    "submitButton": "Gå videre",
                    "continueButton": "Gå videre",
                    "fellAndBrokeNotificationTitle": "Skaden din er av en type som normalt dekkes av Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Gå videre for å opprette en forsikringssak hos forsikringsselskapet.",
                    "stoppedWorkingNotificationTitle": "Ditt problem täcks inte av försäkringen, men kan omfattas av garantin.",
                    "stoppedWorkingNotificationContent": "Kontakta vår support för mer information.",
                    "lostOrStolenNotificationTitle": "Förlust av enhet täcks inte av försäkringen.",
                    "lostOrStolenNotificationContent": "Kontakta vår support för mer information."
                },
                "claimStatus": {
                    "pending": "Swap Service under vurdering",
                    "approved": "Ny enhet sendt",
                    "declined": "Swap Service ble avvist",
                    "completed": "Fullført",
                    "sent": "Retursett sendt",
                    "waitingForPayment": "Har utestående fakturaer",
                    "paymentReceived": "Betalning mottatt",
                    "deviceReceived": "Enhet mottatt",
                    "deviceReceivedDamaged": "Enhet mottatt skadet"
                },
                "formTitle": "Beskriv saken",
                "submitButton": "Registrer og betal",
                "registerButton": "Registrer sak",
                "payButton": "Betale",
                "continueButton": "Fortsett",
                "damageTitle": "Beskriv hva som har skjedd med enheten",
                "damageAdditionalTitle": "Ha bilder av skadene klare (forside, bakside, åpen). Du vil bli bedt om å laste dem opp nedenfor.",
                "damageDate": "Når skjedde skaden?",
                "damageDatePlaceholder": "Velg dato",
                "nextMonth": "Neste måned",
                "prevMonth": "Forrige måned",
                "damageDescription": "Beskriv hva som har skjedd med enheten",
                "damageDescriptionPlaceholder": "Beskriv hva som har skjedd med enheten",
                "damageSpecTitle": "Velg beskrivelsen som passer best til skaden. Du kan velge flere alternativer.",
                "termsLabel": "Jeg har lest og forstått ovennevnte informasjon",
                "summaryTitle": "Søknad om Swap Service",
                "summary": {
                    "overview": {
                        "issues": {
                            "fell-and-broke": "Enheten har en utilsiktet fall- eller vannskade",
                            "lost": "Enhet mistet eller stjålet"
                        }
                    },
                    "returnKitSentNotificationTitle": "Vær oppmerksom på",
                    "returnKitSentNotificationContent": "Vi kommer til å sende deg et retursett for å hjelpe deg med å returnere enheten.",
                    "returnKitSentNotificationLink": "#",
                    "returnKitSentNotificationLinkText": "",
                    "accordionTitle": "Søknad om Swap Service",
                    "certificateTitle": "Saks-ID",
                    "productTitle": "Produkt",
                    "customerTitle": "Kundens navn",
                    "periodTitle": "Startdato for abonnement",
                    "deviceDetailsTitle": "Enhetsdetaljer",
                    "overviewTitle": "Saksoversikt",
                    "overviewIssueTitle": "Type skade",
                    "overviewDamageDescriptionTitle": "Beskrivelse",
                    "overviewDateTitle": "Skadedato",
                    "overviewDamagesTitle": "Skader",
                    "front-side": "Skjermskade - hovedskjerm",
                    "back-side": "Skade på bakside og/eller ramme",
                    "camera": "Skadet kamera",
                    "audio": "Lydproblemer",
                    "network": "Nettverksproblemer",
                    "on-off-problem": "PÅ/AV-problemer",
                    "other": "Annen"
                },
                "notSupportedNotificationTitle": "Tap av enhet dekkes ikke av Swap Service, kostnadene vil variere avhengig av enheten.",
                "notSupportedNotificationContent": "Registrer tapt enhet for å motta et tilbud fra Foxway om erstatningsenhet.",
                "warrantyNotificationTitle": "Ser ut til at problemet ditt er dekket av garantien",
                "warrantyNotificationContent": "Kontakt vår kundestøtte for mer informasjon."
            }
        },
        "privacyPolicy": {
            "title": "Cookie- og databehandlingspolicy",
            "sections": [
                {
                    "title": "1. Bruk av informasjonskapsler og databehandling",
                    "content": "Foxway og dets partnere, inkludert vår finansielle partner Lisa& Friends AB (registrert i Sverige under organisasjonsnummer 934431650, med registrert adresse på c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sverige), bruker informasjonskapsler og lignende teknologier (\"Teknologier\") for å lagre og få tilgang til informasjon på enheten din.\n\nDisse teknologiene er essensielle for å tilby sikre og funksjonelle tjenester, inkludert betalingsprosesser og kundesportal-funksjonaliteter. Ved å akseptere informasjonskapsler, samtykker du til behandlingen av dine data, inkludert deling av relevant informasjon med Lisa& Friends AB for å lette finansielle tjenester og sikre en sømløs opplevelse. Du kan finne mer informasjon om våre datadelingpraksiser i vår <a href=\"https://www.foxway.com/no/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">personvernpolicy</a>."
                },
                {
                    "title": "2. Typer informasjonskapsler vi bruker",
                    "content": "Vi bruker både essensielle og valgfrie informasjonskapsler for å forbedre din opplevelse. Disse inkluderer:",
                    "items": [
                        "Strengt nødvendige informasjonskapsler – Kreves for kjernefunksjonalitet på nettstedet, inkludert sikkerhet og tilgjengelighet.",
                        "Ytelses- og analyseinformasjonskapsler – Hjelper oss med å analysere hvordan nettstedet vårt brukes for å forbedre brukervennlighet og ytelse.",
                        "Markedsførings- og annonseringsinformasjonskapsler – Muliggjør personlig tilpassede annonser og markedsføringskampanjer, inkludert på tredjepartsplattformer."
                    ]
                },
                {
                    "title": "3. Administrere dine informasjonskapselpreferanser",
                    "content": "Du kan administrere dine informasjonskapselpreferanser når som helst:",
                    "items": [
                        "Aksepter alle informasjonskapsler – Aktiverer full funksjonalitet, inkludert personlig tilpasset innhold og markedsføring.",
                        "Avvis ikke-essensielle informasjonskapsler – Tillater kun strengt nødvendige informasjonskapsler.",
                        "Tilpass innstillinger – Juster spesifikke informasjonskapselpreferanser basert på kategorier."
                    ],
                    "footer": "Du kan endre dine samtykkeinnstillinger når som helst ved å klikke \"Tilpass informasjonskapsler\" nederst på nettstedet vårt.\n\nFor mer informasjon om hvordan Foxway behandler dine data, vennligst se vår <a href=\"https://www.foxway.com/no/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">personvernpolicy</a>."
                }
            ]
        },
        "sessionExpires": {
            "title": "Sesjon utløpt",
            "description": "Vil du fortsette økten?",
            "continueButtonText": "Fortsette",
            "cancelButtonText": "Logg ut"
        }
    }
}
